import { useCanGoBack, useRouter, useSearch } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { StudentCreationForm } from '~features/students/ui/student-registration-from';

import { Button } from '~shared/shadcn/ui/button';

export const RegisterStudent = () => {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const { parentId } = useSearch({
    from: '/_auth/register-student',
  });
  return (
    <div className='mt-8'>
      <div className='mx-auto max-w-2xl rounded-lg border bg-white p-6'>
        <div className='mb-6 flex items-center gap-4'>
          {canGoBack ? (
            <Button
              variant={'ghost'}
              className='flex items-center p-2 [&_svg]:size-6'
              onClick={() => {
                router.history.back();
              }}
            >
              <CircleArrowLeft className='size-6' />
            </Button>
          ) : null}

          <h2 className='text-2xl font-bold text-gray-800'>
            Student Registration Form
          </h2>
        </div>
        <StudentCreationForm
          parentId={parentId}
          onSuccess={() => {
            router.history.back();
          }}
        />
      </div>
    </div>
  );
};

export default RegisterStudent;
